import { ethers } from "ethers";
import { Logger } from "./logging";
import { toDecimalString } from "./number";
import { TokenPrices } from "./price";


export interface SwapMetadata {
    bankxPrice: string;
    bankxPriceRaw: any;
    feeRecipient: string;
    isFeeEnabled: boolean;
    isUserBanned: boolean;
    minSwapAmountUSD: string;
    minSwapAmountUSDRaw: any;
    swapFeeInDecimals: string;
    swapFeePercentage: string;
    swapFeeRaw: any;
    walletAddress: string | null;
    xsdPrice: string;
    xsdPriceRaw: any;
}

export const swapMetadataDefault: SwapMetadata = {
    bankxPrice: '',
    bankxPriceRaw: null,
    feeRecipient: '',
    isFeeEnabled: false,
    isUserBanned: false,
    minSwapAmountUSD: '',
    minSwapAmountUSDRaw: null,
    swapFeeInDecimals: '',
    swapFeePercentage: '',
    swapFeeRaw: null,
    walletAddress: '',
    xsdPrice: '',
    xsdPriceRaw: null,
}

export async function getSwapMetadata(routerContract: ethers.Contract, walletAddress: string | null): Promise<SwapMetadata> {
    const promises = [
        '', // routerContract.feeRecipient(),
        false, // routerContract.feesEnabled(),
        '0', // routerContract.swapFee(),
        false, // walletAddress ? routerContract.bannedAddresses(walletAddress) : false,
        routerContract.minSwapAmountUSD(),
        routerContract.getXSDPriceFromPool(),
        routerContract.getBankXPriceFromPool(),
    ];

    const [
        feeRecipient,
        isFeeEnabled,
        swapFee,
        isUserBanned,
        minSwapAmountUSD,
        xsdPrice,
        bankxPrice,
    ] = await Promise.all(promises);

    const decimals = 18;
    const routerPriceDecimals = 6;
    const formattedSwapFee = swapFee;
    const swapFeeInDecimals = Number(formattedSwapFee) / 10000;

    // https://ossllc.atlassian.net/browse/BAN-546
    // double the minSwapAmountUSD
    let formattedMinSwapUSD = String(Number(toDecimalString(minSwapAmountUSD, decimals)) * 2);

    { // adjust and format the minSwapUSD

        // we need to add the swap fee to the minimum
        const fee = 1 + (isFeeEnabled ? swapFeeInDecimals : 0);
        const adjusted = String(Number(formattedMinSwapUSD) * fee);

        // pad the cents
        const [dollar, cents = '00'] = adjusted.split('.');
        const paddedCents = cents.padEnd(2, '0');

        formattedMinSwapUSD = [dollar, paddedCents].join('.');
    }

    let adjustedSwapFeeInDecimals = String(swapFeeInDecimals);
    let adjustedSwapFeePercentage = String(Number(formattedSwapFee) / 100);

    if (!isFeeEnabled) {
        adjustedSwapFeeInDecimals = '0';
        adjustedSwapFeePercentage = '0';
    }

    const result: SwapMetadata = {
        bankxPrice: toDecimalString(bankxPrice, routerPriceDecimals),
        bankxPriceRaw: bankxPrice,
        feeRecipient,
        isFeeEnabled,
        isUserBanned,
        minSwapAmountUSD: formattedMinSwapUSD,
        minSwapAmountUSDRaw: minSwapAmountUSD,
        swapFeeInDecimals: adjustedSwapFeeInDecimals,
        swapFeePercentage: adjustedSwapFeePercentage,
        swapFeeRaw: swapFee,
        walletAddress,
        xsdPrice: toDecimalString(xsdPrice, routerPriceDecimals),
        xsdPriceRaw: xsdPrice,
    }

    Logger.info('getSwapMetadata:', result);

    return result;
}

export async function getTokenPricesFromRouter(_routerContract: ethers.Contract): Promise<TokenPrices> {
    // TODO: we can get bankx price but need a function to get xsd price too
    return {
        xsd: '0',
        bankx: '0',
    };
}
